import { Box, Skeleton, Typography } from "@mui/material";

export const NotificationListLoader = () => {
  return (
    <>
      <Typography variant="h3">
        <Skeleton width="20%" />
      </Typography>
      <Box sx={{ marginTop: "16px", display: "flex", gap: "32px", alignItems: "center" }}>
        <Skeleton animation="wave" variant="circular" width={60} height={60} />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Skeleton animation="wave" variant="text" width="70%" height={20} />
          <Skeleton animation="wave" variant="text" width="45%" height={20} />
        </Box>
      </Box>
      <Box sx={{ marginTop: "16px", display: "flex", gap: "32px", alignItems: "center" }}>
        <Skeleton animation="wave" variant="circular" width={60} height={60} />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Skeleton animation="wave" variant="text" width="70%" height={20} />
          <Skeleton animation="wave" variant="text" width="45%" height={20} />
        </Box>
      </Box>
      <Box sx={{ marginTop: "16px", display: "flex", gap: "32px", alignItems: "center" }}>
        <Skeleton animation="wave" variant="circular" width={60} height={60} />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Skeleton animation="wave" variant="text" width="70%" height={20} />
          <Skeleton animation="wave" variant="text" width="45%" height={20} />
        </Box>
      </Box>
      <Box sx={{ marginTop: "16px", display: "flex", gap: "32px", alignItems: "center" }}>
        <Skeleton animation="wave" variant="circular" width={60} height={60} />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Skeleton animation="wave" variant="text" width="70%" height={20} />
          <Skeleton animation="wave" variant="text" width="45%" height={20} />
        </Box>
      </Box>
      <Box sx={{ marginTop: "16px", display: "flex", gap: "32px", alignItems: "center" }}>
        <Skeleton animation="wave" variant="circular" width={60} height={60} />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Skeleton animation="wave" variant="text" width="70%" height={20} />
          <Skeleton animation="wave" variant="text" width="45%" height={20} />
        </Box>
      </Box>
    </>
  );
};
